import { render, staticRenderFns } from "./PayExpense.vue?vue&type=template&id=28804312&"
import script from "./PayExpense.vue?vue&type=script&lang=js&"
export * from "./PayExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports